import type { AnyError } from "#public"
import type { Result } from "#public"

export const Success = <T, E extends AnyError = AnyError>(value: T): Result<T, E> => ({
  value,
  error: undefined,
})
